import { render } from "./AddHolidaysModal.vue?vue&type=template&id=564d0b7f"
import script from "./AddHolidaysModal.vue?vue&type=script&lang=js"
export * from "./AddHolidaysModal.vue?vue&type=script&lang=js"

import "./AddHolidaysModal.vue?vue&type=style&index=0&id=564d0b7f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__